import { Command } from "clipanion";
import { M8tCommand } from "../../lib/m8t-command.js";
import {
  uninstallCompanion,
  type CompanionInstallState,
} from "../../lib/companion-install.js";
import { defaultLocalCompanionInstallOptions } from "./install.js";

interface WritableLike {
  write(chunk: string): unknown;
}

export async function runCompanionUninstallCommand(
  stdout: WritableLike,
  uninstall: () => Promise<CompanionInstallState>,
): Promise<number> {
  const state = await uninstall();
  if (state.state !== "not-installed") {
    stdout.write("Desktop companions were not completely removed.\n");
    return 1;
  }
  stdout.write("Desktop companions removed for this user.\n");
  return 0;
}

export class CompanionUninstallCommand extends M8tCommand {
  static paths = [["companion", "uninstall"]];
  static usage = Command.Usage({
    description: "Remove only this user's desktop companion installation.",
  });

  async executeCommand(): Promise<number> {
    const options = defaultLocalCompanionInstallOptions();
    return runCompanionUninstallCommand(
      this.context.stdout,
      () => uninstallCompanion(options),
    );
  }
}
